import { TextareaAutosize, useMediaQuery, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { BudgetContext } from "../../../../../../../../hooks/ContextStore";
import ActionButton from "../../../../../../../modules/CustomizeComponent/ActionButton";

export default function CreateIncidental(props) {
  const theme = useTheme();
  const [stats,setStats] = useContext(BudgetContext);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    incidentals,
    handleClose,
    handleClickOpen,
    open,
    client_case_id,
  } = props;

  const entertainment = incidentals
    ? incidentals.filter((pay) => pay.title === "Entertainment")
    : 0;
  const grooming = incidentals
    ? incidentals.filter(
        (pay) => pay.title === "Haircuts and personal grooming"
      )
    : 0;
  const donations = incidentals
    ? incidentals.filter(
        (pay) => pay.title === "Charitable donations/religious expenses"
      )
    : 0;
  const travel = incidentals
    ? incidentals.filter((pay) => pay.title === "Travel")
    : 0;
  const subscriptions = incidentals
    ? incidentals.filter((pay) => pay.title === "Dues and subscriptions")
    : 0;
  const pets = incidentals
    ? incidentals.filter((pay) => pay.title === "Pets")
    : 0;
  const gifts = incidentals
    ? incidentals.filter((pay) => pay.title === "Gifts")
    : 0;
  const [description, setDescription] = useState(null);
  const disable = props.disable;

  const { register, getValues } = useForm({
    mode: "onBlur",
  });

  const postMethod = async(data)=>{
    try {
      const response = await Axios
        .post("api/budget/expense", data)
        .catch((err) => {
          if (err && err.response) console.log("Error", err);
        });

      if (response) {
        let firstTimeData = Object(response.data).hasOwnProperty('data');
        let totalOverview = {};
        if(firstTimeData){
          totalOverview = {
            shortfall: response.data.data[0].shortfall,
            total_expenses: response.data.data[0].total_expenses,
            total_gross_income: response.data.data[0].total_gross_income,
            total_net_income: response.data.data[0].total_net_income,
          };
        }else{
          totalOverview = {
            shortfall: response.data.shortfall,
            total_expenses: response.data.total_expenses,
            total_gross_income: response.data.total_gross_income,
            total_net_income: response.data.total_net_income,
          };
        }
        
        setStats(totalOverview);

      }
    } catch (error) {
      if (error.response.status === 500) {
        console.log(error.response.status);
      }
    }
  }


  const formChangedEntertainment = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      title: "Entertainment",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount !== '' ? formValues.actual_amount : 0,
      projected_amount: formValues.projected_amount !== '' ? formValues.projected_amount : 0,
    };

    postMethod(data);
  };
  const formChangedGrooming = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      title: "Haircuts and personal grooming",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_a !== '' ? formValues.actual_amount_a : 0,
      projected_amount: formValues.projected_amount_a !== '' ? formValues.projected_amount_a : 0,
    };

    postMethod(data);
  };
  const formChangedDonations = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      title: "Charitable donations/religious expenses",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_b !== '' ? formValues.actual_amount_b : 0,
      projected_amount: formValues.projected_amount_b !== '' ? formValues.projected_amount_b : 0,
    };

    postMethod(data);
  };
  const formChangedTravel = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      title: "Travel",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_c !== '' ? formValues.actual_amount_c : 0,
      projected_amount: formValues.projected_amount_c !== '' ? formValues.projected_amount_c : 0,
    };
    postMethod(data);
  };
  const formChangedSubscriptions = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      title: "Dues and subscriptions",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_d !== '' ? formValues.actual_amount_d : 0,
      projected_amount: formValues.projected_amount_d !== '' ? formValues.projected_amount_d : 0,
    };
    postMethod(data);
  };
  const formChangedPets = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      title: "Pets",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_e !== '' ? formValues.actual_amount_e : 0,
      projected_amount: formValues.projected_amount_e !== '' ? formValues.projected_amount_e : 0,
    };
    postMethod(data);
  };
  const formChangedGifts = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      title: "Gifts",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount_f !== '' ? formValues.actual_amount_f : 0,
      projected_amount: formValues.projected_amount_f !== '' ? formValues.projected_amount_f : 0,
    };
    postMethod(data);
  };
  const formChangedDescription = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-incidents",
      description: formValues.description,
      client_case_id: client_case_id,
    };

    Axios.post("api/budget/description/store", data)
      .then((res) => {
      })
      .catch((err) => {
      });
  };

  const fetchDescription = () => {
    Axios.get(
      "api/budget/description/" + client_case_id + "/" + "monthly-incidents"
    )
      .then((res) => {
        setDescription(res.data.data);
      })
      .catch((err) => {
        if ((err && "Error", err)) console.log("Error", err.response);
      });
  };
  const handleSubmit = () =>{
    formChangedEntertainment();
    formChangedGrooming();
    formChangedDonations();
    formChangedTravel();
    formChangedSubscriptions();
    formChangedPets();
    formChangedGifts();
    formChangedDescription();
    handleClose();
  }
  useEffect(() => {
    fetchDescription();
  }, []);
  
  const numInputs = document.querySelectorAll('input[type=number]')

  numInputs.forEach(function(input) {
    input.addEventListener('change', function(e) {
      if (e.target.value == '') {
        e.target.value = 0;
      }
    })
  })
  
  return (
    <div>
      <ActionButton
        disabled={disable}
        onClick={handleClickOpen}
        type="button"
        className="btn btn-primary"
      >
        Edit/Add
      </ActionButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        fullScreen={fullScreen}
        maxWidth={"lg"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Other Incidental Expenses"}
        </DialogTitle>
        <DialogContent>
          <Row className="mb-4">
            <Col>
              <Form.Label className="form-control border-0">Expense</Form.Label>
            </Col>
            <Col>
              <Form.Label className="form-control border-0">
                Actual amount
              </Form.Label>
            </Col>
            <Col>
              <Form.Label className="form-control border-0">
                Projected (future) amount
              </Form.Label>
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Entertainment
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  entertainment.length <= 0 ? 0 : entertainment[0].actual_amount
                }
                {...register("actual_amount", { required: true })}
                // onBlur={formChangedEntertainment}
              />
            </Col>
            <Col>
              <input
                name="projected_amount"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  entertainment.length <= 0
                    ? 0
                    : entertainment[0].projected_amount
                }
                {...register("projected_amount", { required: true })}
                // onBlur={formChangedEntertainment}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Haircuts and personal grooming
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_a"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  grooming.length <= 0 ? 0 : grooming[0].actual_amount
                }
                {...register("actual_amount_a", { required: true })}
                // onBlur={formChangedGrooming}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_a"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  grooming.length <= 0 ? 0 : grooming[0].projected_amount
                }
                {...register("projected_amount_a", { required: true })}
                // onBlur={formChangedGrooming}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Charitable donations/religious expenses
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_b"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  donations.length <= 0 ? 0 : donations[0].actual_amount
                }
                {...register("actual_amount_b", { required: true })}
                // onBlur={formChangedDonations}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_b"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  donations.length <= 0 ? 0 : donations[0].projected_amount
                }
                {...register("projected_amount_b", { required: true })}
                // onBlur={formChangedDonations}
              />
            </Col>
          </Row>

          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">Travel</Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_c"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={travel.length <= 0 ? 0 : travel[0].actual_amount}
                {...register("actual_amount_c", { required: true })}
                // onBlur={formChangedTravel}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_c"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  travel.length <= 0 ? 0 : travel[0].projected_amount
                }
                {...register("projected_amount_c", { required: true })}
                // onBlur={formChangedTravel}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Dues and subscriptions
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_d"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  subscriptions.length <= 0 ? 0 : subscriptions[0].actual_amount
                }
                {...register("actual_amount_d", { required: true })}
                // onBlur={formChangedSubscriptions}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_d"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={
                  subscriptions.length <= 0
                    ? 0
                    : subscriptions[0].projected_amount
                }
                {...register("projected_amount_d", { required: true })}
                // onBlur={formChangedSubscriptions}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">Pets</Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_e"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={pets.length <= 0 ? 0 : pets[0].actual_amount}
                {...register("actual_amount_e", { required: true })}
                // onBlur={formChangedPets}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_e"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={pets.length <= 0 ? 0 : pets[0].projected_amount}
                {...register("projected_amount_e", { required: true })}
                // onBlur={formChangedPets}
              />
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">Gifts</Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount_f"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={gifts.length <= 0 ? 0 : gifts[0].actual_amount}
                {...register("actual_amount_f", { required: true })}
                // onBlur={formChangedGifts}
              />
            </Col>
            <Col>
              <input
                name="projected_amount_f"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                type="number"
                defaultValue={gifts.length <= 0 ? 0 : gifts[0].projected_amount}
                {...register("projected_amount_f", { required: true })}
                // onBlur={formChangedGifts}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label className="form-control border-0">
                *If you feel that you need to explain any of the above further,
                please use the space below to do so:
              </Form.Label>
              <TextareaAutosize
                className={`form-control`}
                aria-label="minimum height"
                minRows={4}
                name="description"
                type="text"
                defaultValue={description ? description.description : ""}
                {...register("description", { required: true })}
                // onBlur={formChangedDescription}
              />
            </Col>
          </Row>
        </DialogContent>
        <DialogActions>
              <ActionButton
                id="kt_login_signin_submit"
                onClick={handleSubmit}
                className={`btn custom-green-button font-weight-bold px-9 py-4 my-3`}
              >
                <span>Submit</span>
              </ActionButton>
            <Button
              onClick={handleClose}
              className={`btn custom-cancel-button font-weight-bold px-9 py-4 my-3`}
            >
              Cancel
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
